import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { User } from '../_models/user';
import { saveAs } from 'file-saver';
import { AuthenticationService } from '../authentication.service';
import { AuthService } from "angularx-social-login";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { OrganisationService } from "../create-organisation/organisation.service";
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { DamserviceService } from "../dam/damservice.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-editboard',
  templateUrl: './editboard.component.html',
  styleUrls: ['./editboard.component.css']
})
export class EditboardComponent implements OnInit {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private organisationService: OrganisationService,
    private uploadService: UploadFilesService,
    private damService: DamserviceService,
    private authService: AuthService,
    private modalService: NgbModal,
    private titleService: Title,
    private metaTagService: Meta,
  ) { }

  title = 'Edit board name';

  boards = [];
  imagesExtension: [];
  workspaces = [];
  fileInfos: [];
  imagesList = [];
  searchText: string = '';
  searchData: string = '';
  workspaceId: any
  workspaceName: string;
  boardId: any;
  boardName: string;
  totalIllusCount: any;
  planName: string;
  ownerEmail: string;
  ownerName: string;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  changeColor= [false, false, false];
  imagesIdList: Array<{id: any, title: string}> = [];
  addedTagList: Array<{tags: string}> = [];
  addTagText: string = '';
  addedTag:string;
  checkedId = -1;
  count: number = 0;
  fileText: string;
  currentUser: User;
  deleteBoardStyle = "none";
  deleteBoardId: any;
  deleteBoardName: string;
  shareStyle = "none";
  currentIllus: any;
  boardHeading: string = '';
  boardname: string = '';
  currentBoard: any;
  userRole: string;
  selectedFiles: FileList;
  progressInfos = [];
  message = '';
  userPic: any;

  mobileView: boolean = false;
  plusButton: boolean = true;
  tagFieldArea: boolean = false;
  imageSelected:boolean = false;
  downloadDelete:boolean = false;
  isFav: boolean = false;
  hideDialogSection: boolean = true;
  searchImageslistSection: boolean = false;
  editBoardSection: boolean = true;

  public selectedIndex;

  @ViewChild('imgMainModal') imgMainModal;
  @ViewChild('imgSearchModal') imgSearchModal;
  @ViewChild('shareModal') shareModal;
  @ViewChildren("checkboxes") checkboxes;

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaTagService.addTags([
      { name: 'description', content: 'A user can edit their board name anytime they want or any number of times. We do not restrict to edit board name in our workspace.'},
      { name: 'keywords', content: 'edit board name, edit board, edit workspace' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;

    }

    if(this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();
    } else {
      this.router.navigate(['/login']);
    }
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    // var boardDetails = JSON.parse(localStorage.getItem('boardDetails'));
    var editBoardDetails = JSON.parse(localStorage.getItem('editBoardDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.boardname = editBoardDetails.boardTitle;
    this.boardId = editBoardDetails.boardId;
    this.listWorkspace();
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          // this.workspaceId = data[0].id;
          // this.workspaceName = data[0].title;
          this.userRole = data[0].role;
          this.ownerListApi();
        }else{
          this.router.navigate(['/create-workspace']);
        }
      });
    }else{
      this.router.navigate(['/login']);
    }
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.userRole = userRole;
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
    this.router.navigate(['/dam']);
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
    });
  }

  newCrafttor(): void {
    this.router.navigate(['/create-organisation']);
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  onSubmit() {
    this.searchImages(this.searchText);
  }

  searchImages(searchText: string = ""){
    this.downloadDelete = false;
    this.imagesIdList = [];
    this.changeColor = [];
    this.imageSelected = false;
    this.damService.searchImages(this.workspaceId, searchText).subscribe((data: any) => {
      this.imagesList = data;
      this.searchData = this.searchText;
      this.editBoardSection = false;
      this.searchImageslistSection = true;
    });
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  peopleClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/people']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  newBoardClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/create-board']);
  }

  settingsClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/settings']);
  }


  deleteBoards(id: any, title: string){
    this.selectedIndex = -1;
    this.damService.deleteBoard(this.workspaceId, title, id).subscribe((data: any) => {
      this.searchImageslistSection = false;
      this.editBoardSection = true;
      this.reStartListing();
    });
  }

  deleteFullBoards(title: string){
    this.selectedIndex = -1;
    this.damService.deleteBoard(this.workspaceId, title, this.boardId).subscribe((data: any) => {
      this.searchImageslistSection = false;
      this.editBoardSection = true;
      this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
        this.boards = data;
      });
    });
  }

  reStartListing(){
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
    });
  }

  downloadImage(currentImageId: any, titleImage: string, boardId: any): void {
    // console.log("Akash Image: : "+titleImage);
    this.damService.downloadImages(this.workspaceId, boardId, currentImageId).subscribe((data: any) => {
      saveAs(data, titleImage)
    },
      (error: any) => {
        if (error.status === 403) {
          // this.openLimitModal(this.limitModal);

        }
        else {
          // this.alert.alert("Alert", "Limit reached! Please login to download", () => {
        }
      }
    );
  }

  addFavouriteImage(imageId: any){
    this.damService.addFavouriteImages(this.workspaceId, imageId).subscribe((data: any) => {
      this.isFav = true;
    });
  }

  removeFavouriteImage(imageId: any, title: string){
    this.damService.removeFavouriteImages(this.workspaceId, imageId, title).subscribe((data: any) => {

    });
  }

  closeDialogDownload(){
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.isFav = false;
    this.addedTagList = [];
    this.searchImages(this.searchText);
  }

  openImgSearchDialog(modal){
    this.addTagText = '';
    this.plusButton = true;
    this.tagFieldArea = false;
    this.imgSearchModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.router.navigate(['/dam/subscription']);
    }
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }

  imageExtensionApi(){
    this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.imagesExtension = data['image_formats'];
    });
  }

  editBoardClick(boardTitle: string, boardId: any){
    this.selectedIndex = -1;
    this.boardname = boardTitle;
    this.boardId = boardId;
    this.searchImageslistSection = false;
    this.editBoardSection = true;
  }

  openDeleteBoardShare(boardId: any, boardName: string) {
    this.deleteBoardId = boardId;
    this.deleteBoardName = boardName;
    this.deleteBoardStyle = "block";
  }

  closeDeleteBoardShare() {
   this.deleteBoardStyle = "none";
  }

  deleteBoard(){
    this.selectedIndex = -1;
    this.damService.deleteBoard(this.workspaceId, this.deleteBoardName, this.deleteBoardId).subscribe((data: any) => {
      this.closeDeleteBoardShare();
      this.allMediaRedirect();
    });
  }

  allMediaRedirect(){
    this.router.navigate(['/dam']);
  }

  showTagFieldData(){
    this.plusButton = false;
    this.tagFieldArea = true;
  }

  onSubmitTag(){
    this.addTagsData(this.addTagText);
  }

  addTagsData(addTagText: string){
    this.addTagText = '';
    this.plusButton = false;
    this.tagFieldArea = true;
    this.damService.addImageTags(this.workspaceId, this.boardId, this.currentIllus.id,
      addTagText).subscribe((data: any) => {
        this.addedTag = data.tag;
        this.addedTagList.push({tags: this.addedTag});
    });
  }

  deleteImageTags(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.currentIllus.tags.splice(i, 1);
    });
  }

  deleteImageTagsList(title: string, i: any){
    this.damService.deleteImageTags(this.workspaceId, this.boardId, this.currentIllus.id, title).subscribe((data: any) => {
      this.addedTagList.splice(i, 1);
    });
  }

  hideDialogClick(){
    if(this.hideDialogSection){
      this.hideDialogSection = false;
    }else{
      this.hideDialogSection = true;
    }
  }

  changeColors(i){
      this.selectedIndex = i;
  }

  boardlistClickNew(boardName: string, boardId: any){
    localStorage.setItem('boardDetails', JSON.stringify({ boardId: boardId, boardTitle: boardName}));
    this.router.navigate(['/dam/'+boardName]);
  }

  editBoard(){
    this.damService.editBoardName(this.workspaceId, this.boardId, this.boardname).subscribe((data: any) => {
      this.boardHeading = data.title;
      localStorage.setItem('editBoardDetails', JSON.stringify({ boardId: this.boardId, boardTitle: this.boardname}));
      this.router.navigate(['/dam/'+this.boardname]);
      // this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      //   this.boards = data;
      //   this.boardname = '';
      //   this.editBoardSection = true;
      //   this.searchImageslistSection = false;
      //   this.uploadService.getFiles(this.workspaceId, this.boardId).subscribe((data: any) => {
      //     this.fileInfos = data['results'];
      //     this.totalIllusCount = data['results'].length;
      //     this.imageExtensionApi();
      //   });
      // });
    });
  }

  openPopupShare() {
    this.shareStyle = "block";
  }

  closePopupShare() {
   this.shareStyle = "none";
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }
}
